import { cn } from '@/lib/utils';
import { useMatchMedia } from '../hooks/useMatchMedia';
import { OS_DESKTOP_MEDIA_QUERY } from '../os/osRouteMeta';
import {
  setMcGrawHillMode,
  useMcGrawHillMode,
  type McGrawHillMode,
} from './mcgrawHillModeStore';
import './mcgrawHillChat.css';

const MODES: ReadonlyArray<{ value: McGrawHillMode; label: string }> = [
  { value: 'clinical', label: 'Clinical' },
  { value: 'study', label: 'Study' },
];

/**
 * mcgraw-hill: the AI desktop's Clinical / Study toggle, a pill in the
 * header's selector slot (ORA-1265, via McGrawHillDesktopSelectors). It
 * writes the mode store, which the desktop's chat transport sends with each
 * turn (ORA-1260): Clinical turns skip Ora study content.
 */
const McGrawHillModeToggle = () => {
  const mode = useMcGrawHillMode();
  // The AI desktop's control only: the phone and classic chat page skip it.
  const isDesktop = useMatchMedia(OS_DESKTOP_MEDIA_QUERY);

  if (!isDesktop) return null;

  return (
    <div className="mcgraw-hill-mode" role="radiogroup" aria-label="Mode">
      {MODES.map(({ value, label }) => (
        <button
          key={value}
          type="button"
          role="radio"
          aria-checked={mode === value}
          className={cn(
            'mcgraw-hill-mode__option',
            mode === value && 'mcgraw-hill-mode__option--active'
          )}
          onClick={() => setMcGrawHillMode(value)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default McGrawHillModeToggle;
